import { Box, Typography, TypographyProps } from "@mui/material";
import { ObjType } from "./BaseEntity";
import { FC } from "react";

/** 契約条件（前払い必須） */
export const IS_MAEBARAI: ObjType = { 
  true: "前払い", 
  false: "後払い",
};

/** テナントステータス */
export const TENANT_STATUS: ObjType = {
  "0": "契約中",
  "1": "トライアル",
  "2": "停止中",
  "3": "未入金",
  "4": "解約済み",
}

/** 契約日検索オプション */
export const TENANT_CONTRACT_DATE_TYPE: ObjType = {
  "0": "指定日に契約が有効",
  "1": "指定日に契約開始",
  "2": "指定日に契約終了",
  "3": "指定日±7日間に契約開始",
  "4": "指定日±7日間に契約終了",
}

/** 契約日検索オプション */
export const IS_TENANT_DELETE: ObjType = {
  false: "未削除",
  true: "削除済み",
}

/** 上位操作 */
export const UPPER_OPERATION: ObjType = {
  "0": "拒否",
  "1": "許可",
  "2": "1階層のみ許可",
}

/***************************************************************
 * UI変更系
 **************************************************************/
interface DeviceUiConverterProps {
  deletedTenantNameProps: {
    isDeleted?: boolean;
    tenantName: string;
  },
}
export class DeviceUiConverter {
  // 削除されている場合のテナント名の表示を取得
  public static getDeletedTenantNameString: FC<DeviceUiConverterProps["deletedTenantNameProps"]> = ({
    isDeleted = false,
    tenantName,
  }) => {
    return (
      (isDeleted) ? <>
        <del>{tenantName}</del>
      </> : <>
        {tenantName}
      </>
    );
  }
}